var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hMap"},[_c('apexcharts',{attrs:{"width":"100%","height":"80","type":"heatmap","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }